enum STATE {
	NONE,
	LOADING,
	LOADED,
	ERROR,
	SUBMITTING,
	SUBMITTED,
	FAILED,
}

export default STATE;
